import { Select, Tabs, Button, Drawer } from "antd";
import React, { useState, useEffect, useMemo } from 'react';
import { useCallback } from "react";
import { useCookies } from 'react-cookie';
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "store";
import { 
  setSelectedDashboard, 
  initializeClients, 
  getTotalCountWithServiceStatus, 
  getTotalIssuesCountWithType, 
  getRiderScoreGroups, 
  pendingIssues, 
  getTripsCountAndTotalKmDriven, 
  countIssuesByStatusByClient, 
  getRidersCount, 
  onChangeVehiclesFilters, 
  getClients, 
  getFeedbackStats
} from "store/actions";
import { DashboardState } from "types";
import { ROUTES } from "utils/constants";
import { DatePicker, Form } from 'antd';
import { getNetSwapsCountbyDateByClient, initializeCustomerBilling, setCustomerBill, setTotalBill } from "../../store/actions/billing-actions";
import { useHistory } from "react-router-dom";
import dayjs from "dayjs";
import moment from "moment";
import { parseOrganizationClients } from "../../utils/parsers";
import { IssueStatus } from "protobuf/issue_service_pb";
import {
  FilterOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import "styles/components/tab-headers/dashboard-header.scss";

const { Option } = Select;
const { RangePicker } = DatePicker; 
const { TabPane } = Tabs;

const ALL_TABS = [
  { key: 'vehicles', tab: 'Vehicles' },
  { key: 'financials', tab: 'Financials' },
];

export default function DashboardHeader() {
  const dispatch = useDispatch();
  const [{ meta }] = useCookies();
  const history = useHistory();

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isTablet, setIsTablet] = useState(
    window.innerWidth >= 768 && window.innerWidth < 1024
  );
  const [isExtraSmall, setIsExtraSmall] = useState(window.innerWidth < 300);

  const { clients, search, filters: { listType } } = useSelector<AppState, AppState["vehicles"]>(
    (state) => state.vehicles
  );

  const data = useMemo(
    () => parseOrganizationClients(search, clients),
    [clients, listType, search]
  );

  const {
    common: { userType = 1 },
  } = useSelector<AppState, AppState>((state) => state);
  
  const DASHBOARD_TABS = ALL_TABS;

  const { selectedDashboard } = useSelector<AppState, AppState["dashboard"]>(
    (state) => state.dashboard
  );

  const [selectedDate, setSelectedDate] = useState<string | null>(dayjs().format('YYYY-MM-DD'));
  const [selectedOrganization, setSelectedOrganization] = useState<string | null>(null);
  const [customDateRange, setCustomDateRange] = useState<[string, string] | null>(null);
  const [showRangePicker, setShowRangePicker] = useState(false);
  const [activeTab, setActiveTab] = useState(DASHBOARD_TABS[0].key);
  const [selectedFilter, setSelectedFilter] = useState("this month");

  const {
    filters: { updated },
  } = useSelector<AppState, AppState["issues"]>((state) => state.issues);
  
  const {
    filters: { updated: vehicleUpdated },
  } = useSelector<AppState, AppState["vehicles"]>((state) => state.vehicles);

  const { totalBill, bill } = useSelector((state: AppState) => state.billing);

  // Handle responsive breakpoints
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      setIsTablet(window.innerWidth >= 768 && window.innerWidth < 1024);
      setIsExtraSmall(window.innerWidth < 300);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    console.log("Here in dasboard and selceted dashboard: ", selectedDashboard)
    if (!selectedDashboard || selectedDashboard == "vehicles") {
      dispatch(getClients());
      dispatch(setSelectedDashboard("vehicles"));
      setActiveTab("vehicles");
    } else {
      dispatch(initializeClients(1));
      setActiveTab(selectedDashboard);
    }
  }, [dispatch, selectedDashboard]);

  useEffect(() => {
    if (data && data.length > 0 && selectedOrganization === null) {
      const orgId = data[0].raw.id;
      setSelectedOrganization(orgId);
      if (selectedDate) {
        const month = dayjs(selectedDate).month() + 1;
        const year = dayjs(selectedDate).year();
        dispatch(setCustomerBill({
          billNo: 0,
          customerNo: 0,
          customerName: "",
          customerId: "",
          subscriptionNo: 0,
          issueDate: "",
          postingDate: "",
          dueDate: "",
          status: "",
          lateFeeApplied: 0,
          pb_package: "",
          plan: "",
          batch: "",
          term: "",
          perSwapCost: "",
          totalOperationalBikes: 0,
          billingMonth: month,
          billingYear: year,
          vehicleLicencePlate: "",
          billingItems: '{"lineItems":[{"name":"Swaps","quantity":0,"rate":0,"total":0},{"name":"Battery Sub Charges","quantity":0,"rate":0,"total":0}],"dynamic_items":[]}',
          startdate: "",
          endate: "",
          mileageReadings: "",
        }));
        dispatch(setTotalBill("PKR 0"));
      }
    }
  }, [data, selectedOrganization]);

  const handleOrganizationChange = (value: string) => {
    setSelectedOrganization(value);
    if (value && selectedDate) {
      const month = dayjs(selectedDate).month() + 1;
      const year = dayjs(selectedDate).year();
      dispatch(setCustomerBill({
        billNo: 0,
        customerNo: 0,
        customerName: "",
        customerId: "",
        subscriptionNo: 0,
        issueDate: "",
        postingDate: "",
        dueDate: "",
        status: "",
        lateFeeApplied: 0,
        pb_package: "",
        plan: "",
        batch: "",
        term: "",
        perSwapCost: "",
        totalOperationalBikes: 0,
        billingMonth: month,
        billingYear: year,
        vehicleLicencePlate: "",
        billingItems: '{"lineItems":[{"name":"Swaps","quantity":0,"rate":0,"total":0},{"name":"Battery Sub Charges","quantity":0,"rate":0,"total":0}],"dynamic_items":[]}',
        startdate: "",
        endate: "",
        mileageReadings: "",
      }));
      dispatch(setTotalBill("PKR 0"));
    }
    setMobileMenuOpen(false);
  };

  const onTabChange = (key: string) => {
    setActiveTab(key);
    onChange(key as DashboardState["selectedDashboard"]);
  };

  const onChange = useCallback(
    (value: DashboardState["selectedDashboard"]) => {
      dispatch(setSelectedDashboard(value));
    },
    [dispatch]
  );

  const handleFilterChange = (value: string) => {
    setSelectedFilter(value);
    if (value === "custom") {
      setShowRangePicker(true);
    } else {
      setShowRangePicker(false);
    }
    setMobileMenuOpen(false);
  };

  const handleDateRangeChange = (dates: any, dateStrings: [string, string]) => {
    setCustomDateRange(dateStrings);
  };

  const disabledDate = (current: any) => {
    return current && current > dayjs().endOf("day");
  };

  const handleDateChange = (date: moment.Moment | null, dateString: string) => {
    if (date) {
      const formattedDate = date.format('YYYY-MM-DD');
      const month = dayjs(formattedDate).month() + 1;
      const year = dayjs(formattedDate).year();
      setSelectedDate(formattedDate);
      dispatch(setCustomerBill({
        billNo: 0,
        customerNo: 0,
        customerName: "",
        customerId: "",
        subscriptionNo: 0,
        issueDate: "",
        postingDate: "",
        dueDate: "",
        status: "",
        lateFeeApplied: 0,
        pb_package: "",
        plan: "",
        batch: "",
        term: "",
        perSwapCost: "",
        totalOperationalBikes: 0,
        billingMonth: month,
        billingYear: year,
        vehicleLicencePlate: "",
        billingItems: '{"lineItems":[{"name":"Swaps","quantity":0,"rate":0,"total":0},{"name":"Battery Sub Charges","quantity":0,"rate":0,"total":0}],"dynamic_items":[]}',
        startdate: "",
        endate: "",
        mileageReadings: "",
      }));
      dispatch(setTotalBill("PKR 0"));
    } else {
      setSelectedDate(null);
    }
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    if (selectedDashboard === "financials" && selectedDate) {
      if (meta?.user?.organizationId && selectedDate) {
        dispatch(setCustomerBill({
          billNo: 0,
          customerNo: 0,
          customerName: "",
          customerId: "",
          subscriptionNo: 0,
          issueDate: "",
          postingDate: "",
          dueDate: "",
          status: "",
          lateFeeApplied: 0,
          pb_package: "",
          plan: "",
          batch: "",
          term: "",
          perSwapCost: "",
          totalOperationalBikes: 0,
          billingMonth: selectedDate ? dayjs(selectedDate).month() + 1 : 0,
          billingYear: selectedDate ? dayjs(selectedDate).year() : 0,
          vehicleLicencePlate: "",
          billingItems: '{"lineItems":[{"name":"Swaps","quantity":0,"rate":0,"total":0},{"name":"Battery Sub Charges","quantity":0,"rate":0,"total":0}],"dynamic_items":[]}',
          startdate: "",
          endate: "",
          mileageReadings: "",
        }));
        dispatch(setTotalBill("PKR 0"));
        dispatch(initializeCustomerBilling({ 
          organization_id: selectedOrganization || meta.user.organizationId, 
          date: selectedDate 
        }));
      }
    }
  }, [dispatch, meta, selectedDate, selectedDashboard, userType, selectedOrganization]);

  const showOrganizationDropdown = userType === 2;
  const defaultOrganization = data?.length > 0 ? data[0].raw.name : null;

  useEffect(() => {
    let startDate = "";
    let endDate = dayjs().format("YYYY-MM-DD");
  
    if (selectedFilter === "this month") {
      startDate = dayjs().startOf("month").format("YYYY-MM-DD");
      endDate = dayjs().endOf("month").format("YYYY-MM-DD");
    } else if (selectedFilter === "this week") {
      startDate = dayjs().startOf("week").format("YYYY-MM-DD");
      endDate = dayjs().endOf("week").format("YYYY-MM-DD");
    } else if (selectedFilter === "today") {
      startDate = dayjs().format("YYYY-MM-DD");
      endDate = dayjs().format("YYYY-MM-DD");
    } else if (selectedFilter === "custom" && customDateRange) {
      startDate = customDateRange[0];
      endDate = customDateRange[1];
    }
  
    if (selectedDashboard === "vehicles") {
      dispatch(
        getTotalCountWithServiceStatus({
          client_id: selectedOrganization || meta.user.organizationId,
          start_date: startDate,
          end_date: endDate,
        })
      );

      dispatch(
        getTotalIssuesCountWithType({
          client_id: selectedOrganization || meta.user.organizationId,
          start_date: startDate,
          end_date: endDate,
        })
      );

      dispatch(
        countIssuesByStatusByClient({
          client_id: selectedOrganization || meta.user.organizationId,
          start_date: startDate,
          end_date: endDate,
          status: IssueStatus.Enum.PENDING
        })
      );

      dispatch(
        getRiderScoreGroups({
          organization_id: selectedOrganization || meta.user.organizationId,
          start_date: startDate,
          end_date: endDate,
        })
      );

      dispatch(pendingIssues(selectedOrganization || meta.user.organizationId, 1, updated, "current"));

      dispatch(
        getTripsCountAndTotalKmDriven({
          client_id: selectedOrganization || meta.user.organizationId,
          start_date: startDate,
          end_date: endDate,
        })
      );

      dispatch(
        getNetSwapsCountbyDateByClient({
          client_id: selectedOrganization || meta.user.organizationId,
          start_date: startDate,
          end_date: endDate,
        })
      );

      dispatch(
        getRidersCount({
          client_id: selectedOrganization || meta.user.organizationId,
        })
      );
         dispatch(
        getFeedbackStats()
      );
    }
  }, [dispatch, meta, selectedDate, selectedDashboard, userType, selectedOrganization, selectedFilter, customDateRange, updated, vehicleUpdated]);

  // Get filter label for display
  const getFilterLabel = () => {
    if (selectedDashboard === "vehicles") {
      if (selectedFilter === "this month") return "Month";
      if (selectedFilter === "this week") return "Week";
      if (selectedFilter === "today") return "Today";
      if (selectedFilter === "custom" && customDateRange) {
        return `${moment(customDateRange[0]).format('MMM DD')} - ${moment(customDateRange[1]).format('MMM DD')}`;
      }
      return "Custom";
    } else {
      return selectedDate ? moment(selectedDate).format('MMM YYYY') : 'Select';
    }
  };

  // Mobile menu content
  const mobileMenuContent = (
    <div className="mobile-menu-content">
      {/* Client Selection */}
      {showOrganizationDropdown && (
        <div className="mobile-menu-section">
          <h4 className="section-title">Select Client</h4>
          <Select 
            showSearch
            defaultValue={defaultOrganization ?? data[0]?.raw.name} 
            onChange={handleOrganizationChange} 
            style={{ width: '100%' }}
            optionFilterProp="children"
            filterOption={(input, option) =>
              option?.children?.toLowerCase().includes(input.toLowerCase())
            }
          >
            {data?.map((organization) => (
              <Option key={organization.raw.id} value={organization.raw.id}>
                {organization.name}
              </Option>
            ))}
          </Select>
        </div>
      )}

      {/* Date/Filter Selection */}
      {selectedDashboard !== "vehicles" ? (
        <div className="mobile-menu-section">
          <h4 className="section-title">Month and Year</h4>
          <DatePicker
            style={{ width: '100%' }} 
            picker="month"
            format="MMMM YYYY"
            defaultValue={moment()}
            onChange={handleDateChange}
            disabledDate={(current) => {
              return current && current > moment().endOf("month");
            }}
          />
        </div>
      ) : (
        <>
          <div className="mobile-menu-section">
            <h4 className="section-title">Filter Options</h4>
            <Select
              defaultValue="this month"
              value={selectedFilter}
              onChange={handleFilterChange}
              style={{ width: '100%' }}
            >
              <Option value="this month">This Month</Option>
              <Option value="this week">This Week</Option>
              <Option value="today">Today</Option>
              <Option value="custom">Custom Range</Option>
            </Select>
          </div>

          {selectedFilter === 'custom' && (
            <div className="mobile-menu-section">
              <h4 className="section-title">Custom Date Range</h4>
              <RangePicker
                onChange={handleDateRangeChange}
                style={{ width: '100%' }} 
                picker="date"
                format="YYYY-MM-DD"
                ranges={{
                  "Last 7 Days": [moment().subtract(7, "days"), moment()],
                  "Last 15 Days": [moment().subtract(15, "days"), moment()],
                  "This Month": [moment().startOf("month"), moment()],
                }}
                disabledDate={disabledDate}
              />
            </div>
          )}
        </>
      )}
    </div>
  );

  // Maroon/Primary color
  const primaryColor = "#800000";

  return (
    <div className="common-header dashboard-header-container">
      {/* Mobile & Tablet View (<1024px) */}
      <div className="header-mobile">
        <div className="mobile-top-row">
          {/* Tabs */}
          <div className="mobile-tabs-wrapper">
            <Tabs activeKey={activeTab} onChange={onTabChange} size="small">
              {DASHBOARD_TABS.map((tab) => (
                <TabPane tab={tab.tab} key={tab.key} />
              ))}
            </Tabs>
          </div>

          {/* Filter/Date Info Display */}
          <div className="mobile-filter-info">
            <span 
              className="filter-badge"
              style={{
                backgroundColor: primaryColor,
                color: '#ffffff',
                padding: '4px 12px',
                borderRadius: '16px',
                fontSize: '12px',
                fontWeight: 500,
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px',
              }}
            >
              {selectedDashboard === "vehicles" ? (
                <><FilterOutlined style={{ color: '#ffffff' }} /> {getFilterLabel()}</>
              ) : (
                <><CalendarOutlined style={{ color: '#ffffff' }} /> {getFilterLabel()}</>
              )}
            </span>
          </div>

          {/* Filter Button */}
          <Button
            type="text"
            icon={<FilterOutlined style={{ color: primaryColor, fontSize: '18px' }} />}
            onClick={() => setMobileMenuOpen(true)}
            className="mobile-filter-btn"
            style={{
              border: `1px solid ${primaryColor}`,
              borderRadius: '6px',
              padding: '4px 8px',
              height: 'auto',
            }}
          />
        </div>
      </div>

      {/* Desktop View (≥1024px) - ONE LINER */}
      <div className="header-desktop">
        <div 
          className="desktop-one-liner"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 20px',
            width: '100%',
            flexWrap: 'nowrap',
            gap: selectedDashboard !== "vehicles" ? '336px': '416px',
          }}
        >
          {/* Left: Tabs */}
          <div className="desktop-tabs" style={{ flexShrink: 0 }}>
            <Tabs 
              activeKey={activeTab} 
              onChange={onTabChange}
              style={{ marginBottom: 0 }}
            >
              {DASHBOARD_TABS.map((tab) => (
                <TabPane tab={tab.tab} key={tab.key} />
              ))}
            </Tabs>
          </div>

          {/* Right: Controls pushed to right corner */}
          <div 
            className="desktop-controls"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '24px',
              flexShrink: 0,
              marginLeft: 'auto',
              paddingRight: '10px',
            }}
          >
            {/* Client Selection */}
            {showOrganizationDropdown && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ whiteSpace: 'nowrap', fontWeight: 500, color: '#333' }}>
                  Select Client:
                </span>
                <Select 
                  showSearch
                  defaultValue={defaultOrganization ?? data[0]?.raw.name} 
                  onChange={handleOrganizationChange} 
                  style={{ width: 180 }}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option?.children?.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {data?.map((organization) => (
                    <Option key={organization.raw.id} value={organization.raw.id}>
                      {organization.name}
                    </Option>
                  ))}
                </Select>
              </div>
            )}

            {/* Date/Filter Controls */}
            {selectedDashboard !== "vehicles" ? (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ whiteSpace: 'nowrap', fontWeight: 500, color: '#333' }}>
                  Month and Year:
                </span>
                <DatePicker
                  style={{ width: 160 }} 
                  picker="month"
                  format="MMMM YYYY"
                  defaultValue={moment()}
                  onChange={handleDateChange}
                  disabledDate={(current) => {
                    return current && current > moment().endOf("month");
                  }}
                />
              </div>
            ) : (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {selectedFilter === 'custom' && showRangePicker ? (
                  <>
                    <span style={{ whiteSpace: 'nowrap', fontWeight: 500, color: '#333' }}>
                      Date Range:
                    </span>
                    <RangePicker
                      onChange={handleDateRangeChange}
                      style={{ width: 260 }} 
                      picker="date"
                      format="YYYY-MM-DD"
                      ranges={{
                        "Last 7 Days": [moment().subtract(7, "days"), moment()],
                        "Last 15 Days": [moment().subtract(15, "days"), moment()],
                        "This Month": [moment().startOf("month"), moment()],
                      }}
                      defaultPickerValue={[moment().subtract(30, "days"), moment().subtract(30, "days")]}
                      disabledDate={disabledDate}
                    />
                    <span
                      style={{
                        cursor: "pointer",
                        color: primaryColor,
                        fontSize: "16px",
                        fontWeight: 'bold',
                        marginLeft: '4px',
                      }}
                      onClick={() => {
                        setShowRangePicker(false);
                        setSelectedFilter("this month");
                      }}
                    >
                      ✖
                    </span>
                  </>
                ) : (
                  <>
                    <span style={{ whiteSpace: 'nowrap', fontWeight: 500, color: '#333' }}>
                      Filter:
                    </span>
                    <Select
                      defaultValue="this month"
                      value={selectedFilter}
                      onChange={handleFilterChange}
                      style={{ width: 140 }}
                    >
                      <Option value="this month">This Month</Option>
                      <Option value="this week">This Week</Option>
                      <Option value="today">Today</Option>
                      <Option value="custom">Custom</Option>
                    </Select>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Mobile Drawer */}
      <Drawer
        title={
          <span style={{ color: primaryColor, fontWeight: 600 }}>
            Filter Options
          </span>
        }
        placement="right"
        onClose={() => setMobileMenuOpen(false)}
        visible={mobileMenuOpen}
        className="dashboard-mobile-drawer"
        width={isExtraSmall ? "90%" : 280}
        headerStyle={{ borderBottom: `2px solid ${primaryColor}` }}
      >
        {mobileMenuContent}
      </Drawer>
    </div>
  );
}